import { Button, Empty, Spin, Table, Typography, Select, Input } from "antd";
import { useEffect, useState } from "react";

import {
	DownloadOutlined,
	LoadingOutlined,
	SearchOutlined,
} from "@ant-design/icons";
import report from "../../../../apis/admin/report";
import notificationHandler from "../../../atoms/Notification";
import "moment/locale/vi";
import { Link } from "react-router-dom";
import { set } from "ramda";
const ReportQuestion = () => {
	const [date, setDate] = useState([]);
	const [type, setType] = useState("");
	const [values, setValue] = useState<any>("");
	const [dataReport, setDataReport] = useState<any>([]);
	const [loading, setLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const types = [
		{
			label: "Tự luận",
			value: 0,
		},
		{
			label: "Trắc nghiệm",
			value: 1,
		},
	];
	const handlePageChange = (page: any) => {
		setCurrentPage(page);
	};

	const [pageSize, setPageSize] = useState(10);

	const displayedIndex = (index: any) =>
		(currentPage - 1) * pageSize + index + 1;
	const { Title } = Typography;

	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	useEffect(() => {
		setLoading(true);
		report
			.searchQuestions(type, values)
			.then((res: any) => {
				setDataReport(res.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
			})
			.finally(() => setLoading(false));
	}, []);
	const exportExcel = () => {
		report
			.questionsExport("", date[0] || "", date[1] || "")
			.then((res: any) => {
				const url = window.URL.createObjectURL(new Blob([res.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "Báo cáo câu hỏi.xlsx");
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			})
			.catch((err: any) => {
				notificationHandler("error", "Xuất file exel không thành công");
			});
	};

	const handleDownload = (id: number) => {
		setLoading(true);
		report
			.getQuestionStatisticsExcel(id)
			.then((res: any) => {
				const blob = new Blob([res.data]);
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", `question_statistics_${id}.xlsx`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((err: any) => {
				notificationHandler("error", "Xuất file exel không thành công");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const handleSearch = () => {
		report
			.searchQuestions(type, values)
			.then((res: any) => {
				setDataReport(res.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", "Không tìm thấy dữ liệu");
				setDataReport(null);
			});
	};

	const handleSearchType = (value: string) => {
		if (value == undefined) return;
		setType(value);

		report
			.searchQuestions(value, values)
			.then((res: any) => {
				setDataReport(res.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", "Không tìm thấy dữ liệu");
				setDataReport(null);
			});
	};

	const onSearch = (value: string) => {
		if (value == undefined) return;
		setValue(value);

		report
			.searchQuestions(type, value)
			.then((res: any) => {
				setDataReport(res.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", "Không tìm thấy dữ liệu");
				setDataReport(null);
			});
	};

	const columns = [
		{
			title: "STT",
			dataIndex: "index",
			key: "index",
			render: (_: any, __: any, index: any) => displayedIndex(index),
		},
		{
			title: "Thao tác",
			dataIndex: "id",
			key: "id",
			width: 100,
			render: (value: number) => {
				return (
					<Button
						onClick={() => handleDownload(value)}
						type="text"
						icon={<DownloadOutlined />}
					></Button>
				);
			},
		},
		{
			title: "Câu hỏi",
			dataIndex: "content",
			key: "content",
			render: (_: unknown, record: any) => {
				return (
					<Link
						className="text-[#1677FF]"
						to={`/admin/ReportQuestionDetailPage/${record.id}`}
					>
						{record.content}
					</Link>
				);
			},
		},
		{
			title: "Số lượng câu trả lời",
			dataIndex: "customerAnsweredCount",
			key: "customerAnsweredCount",
		},
		{
			title: "Tỷ lệ trả lời",
			dataIndex: "customerAnsweredRate",
			key: "customerAnsweredRate",
			render: (value: string) => {
				return `${value}%`;
			},
		},
		{
			title: "Phân loại câu hỏi",
			dataIndex: "type",
			key: "type",
			render: (value: number) => {
				const typeQuestion = types.find((item: any) => item.value === value);
				return typeQuestion ? typeQuestion.label : "-";
			},
		},
	];
	return (
		<div>
			<Spin indicator={antIcon} spinning={loading} />
			<div>
				<div className="flex justify-between my-3">
					<div className="flex w-[70%]">
						<Input
							style={{ width: "30%" }}
							placeholder="Nhập tên tìm kiếm"
							maxLength={200}
							onChange={(e) => onSearch(e.target.value)}
							onBlur={(e) => setValue(e.target.value.trim())}
							prefix={<SearchOutlined />}
							allowClear
							value={values}
						/>
						<Select
							style={{ width: "15%" }}
							className="ml-3"
							onChange={handleSearchType}
							placeholder={"Chọn loại câu hỏi"}
							allowClear
							options={[
								// { value: "", label: "Chọn loại câu hỏi" },
								{ value: 1, label: "Trắc nghiệm" },
								{ value: 0, label: "Tự luận" },
							]}
						/>
						<Button
							icon={<SearchOutlined />}
							onClick={handleSearch}
							className="ml-3 bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white text-white"
						>
							Tìm kiếm
						</Button>
						<Button
							type="primary"
							className="ml-3 bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white"
							icon={<DownloadOutlined />}
							onClick={() => {
								exportExcel();
							}}
						>
							Xuất báo cáo
						</Button>
					</div>
				</div>
			</div>
			<Title className="mt-[20px]" level={3}>
				Danh sách câu hỏi khảo sát
			</Title>
			<Table
				dataSource={dataReport}
				pagination={{
					current: currentPage,
					locale: { items_per_page: "bản ghi / Trang" },
					defaultPageSize: 10,
					onChange: handlePageChange,
					showSizeChanger: true,
					pageSizeOptions: ["10", "20", "50"],
					onShowSizeChange(current, size) {
						setPageSize(size);
					},
					showTotal: (total: any, range: any) =>
						`${range[0]}-${range[1]} Tổng ${total} bản ghi`,
				}}
				rowKey={(recod) => recod.id}
				columns={columns}
				className="mt-[15px]"
				locale={{
					emptyText: (
						<Empty
							image={Empty.PRESENTED_IMAGE_DEFAULT}
							description="Không có dữ liệu!"
						/>
					),
				}}
			/>
		</div>
	);
};

export default ReportQuestion;
